import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
export default (function t(e) {
  function r(t, e, n) {
    var a,
        o = {};
    if (Array.isArray(t)) return t.concat(e);

    for (a in t) {
      o[n ? a.toLowerCase() : a] = t[a];
    }

    for (a in e) {
      var i = n ? a.toLowerCase() : a,
          u = e[a];
      o[i] = i in o && "object" == typeof u ? r(o[i], u, "headers" === i) : u;
    }

    return o;
  }

  function n(t, n, a, o) {
    "string" != typeof t && (t = (n = t).url);
    var i = {
      config: n
    },
        u = r(e, n),
        s = {},
        c = o || u.data;
    (u.transformRequest || []).map(function (t) {
      c = t(c, u.headers) || c;
    }), c && "object" == typeof c && "function" != typeof c.append && (c = JSON.stringify(c), s["content-type"] = "application/json");
    var f = document.cookie.match(RegExp("(^|; )" + u.xsrfCookieName + "=([^;]*)"));

    if (f && (s[u.xsrfHeaderName] = f[2]), u.auth && (s.authorization = u.auth), u.baseURL && (t = new URL(t, u.baseURL) + ""), u.params) {
      var p = ~t.indexOf("?") ? "&" : "?";
      t += p + (u.paramsSerializer ? u.paramsSerializer(u.params) : new URLSearchParams(u.params));
    }

    return (u.fetch || fetch)(t, {
      method: a || u.method,
      body: c,
      headers: r(u.headers, s, !0),
      credentials: u.withCredentials ? "include" : void 0
    }).then(function (t) {
      for (var e in t) {
        "function" != typeof t[e] && (i[e] = t[e]);
      }

      return (u.validateStatus ? u.validateStatus(t.status) : t.ok) ? "stream" == u.responseType ? (i.data = t.body, i) : t[u.responseType || "text"]().then(function (t) {
        i.data = t, i.data = JSON.parse(t);
      })["catch"](Object).then(function () {
        return i;
      }) : Promise.reject(i);
    });
  }

  return e = e || {}, n.request = n, n.get = function (t, e) {
    return n(t, e, "get");
  }, n["delete"] = function (t, e) {
    return n(t, e, "delete");
  }, n.options = function (t, e) {
    return n(t, e, "options");
  }, n.post = function (t, e, r) {
    return n(t, r, "post", e);
  }, n.put = function (t, e, r) {
    return n(t, r, "put", e);
  }, n.patch = function (t, e, r) {
    return n(t, r, "patch", e);
  }, n.all = Promise.all, n.spread = function (t) {
    return function (e) {
      return t.apply(this, e);
    };
  }, n.CancelToken = "function" == typeof AbortController ? AbortController : Object, n.defaults = e, n.create = t, n;
})();